module.exports = __webpack_public_path__ + "static/media/creditEligible.6f339700.svg";